import { render } from "./DashboardHelper.vue?vue&type=template&id=5975124e"
import script from "./DashboardHelper.vue?vue&type=script&lang=js"
export * from "./DashboardHelper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__